//
//
//
//

import RegisterForm from '../components/forms/RegisterForm';

export default {
	auth: false,
	name: 'Register',
	components: {
		RegisterForm,
	},
	head() {
		return {
			title: 'Crear cuenta  | La Reverde',
		};
	},
};
